import React from 'react';
import { Combo } from 'fw/forms';
import { EmailCategory } from 'areas/shared/consts';

class EmailCategoryCombo extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {}
	}

	completed = () => { return this._ctrl.completed(); }
	flag = (s) => { return this._ctrl.flag(s); }

	componentDidMount() {
		var items= Object.entries(EmailCategory.ITEMS).map(
			([key, value]) => { 
				return { label: key, value: value };
			}
		);
					
		this.setState({items: items});
	}
	
	render() {
		return (
			<Combo
				{...this.props}
                placeholder={this.props.placeholder}
				items={this.state.items}
				searchable={false}
				ref={(c) => { this._ctrl = c }} />
		)
	}
}

export default EmailCategoryCombo;

// Mark this as a form component
EmailCategoryCombo.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Select..."
};


// WEBPACK FOOTER //
// ./src/areas/shared/controls/emailCategoryCombo/EmailCategoryCombo.js